export const HEADERS = [
  'Tipo de Arquivo',
  'Nome do Documento/Registro',
  'Rev.',
  'Data da Vigência',
  'Data de Criação',
  'Data da Conclusão',
  'Status',
  'Etapa',
  'Ações',
];

export const DOCUMENT_SEARCH_URL = '/documents/search';
